import { HTTP_WITHOUT_HEADER, HTTP } from '../../utils'

export const getSSOConfiguration = () => {
  return HTTP_WITHOUT_HEADER().get('configuration/prelogin/sso_configuration')
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const getEnvironment = () => {
  return HTTP_WITHOUT_HEADER().get('configuration')
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const resetPassword = (email) => {
  return HTTP_WITHOUT_HEADER().get('user/resetPassword/' + email)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const verifyUser = (data) => {
  return HTTP_WITHOUT_HEADER().post('user/verify', data)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const signUpUser = (campaignId, institutionOpenId, data) => {
  return HTTP_WITHOUT_HEADER().post('user/registerProspectiveStudent/emailCampaign/' + institutionOpenId + '/' + campaignId, data)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const postWidgetAdminSignUp = (institutionOpenId, data) => {
  return HTTP_WITHOUT_HEADER().put('/precuratedInstitution/processSignUp?externalId=' + institutionOpenId, data)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const postWidgetAdminSignUpNotOnList = (data) => {
  return HTTP_WITHOUT_HEADER().put('/precuratedInstitution/processSignUpNotOnList', data)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}


export const updateEmailCampaignClicks = (campaignId, institutionOpenId) => {
  return HTTP_WITHOUT_HEADER().get('emailcampaign/updateClicks/' + institutionOpenId + '/' + campaignId)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const getInstitutionMeta = (institutionOpenId) => {
  return HTTP_WITHOUT_HEADER().get('institution/meta/' + institutionOpenId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    return e.response
  })
}

export const loginUser = (data) => {
  let loginUrl = 'user/login'
  if(data.institutionId){
    loginUrl +='/'+data.institutionId
  }
  return HTTP_WITHOUT_HEADER().post(loginUrl, data)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const shibLoginUser = (token) => {
  return HTTP(token).get('shibboleth/user?token=' + token)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const extendUserSession = (token) => {
  return HTTP().get('user/session/extendValidity?token=' + token)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e.response)
  })
}

export const getPreCuratedInstitutions = () => {
  return HTTP_WITHOUT_HEADER().get('/precuratedInstitution/searchAll?page=0&count=10000')
  .then(response => {
    return response.data
  })
  .catch(e => {
    return e.response
  })
}

export const learnerSelfRegistration = (orgId, user) => {
  return HTTP_WITHOUT_HEADER().put('/user/learnerSelfRegistration/' + orgId, user)
  .then(res => {
    return res.data
  })
  .catch(e => {
    return e.response
  })
}

export const verifySelfRegistration = (data) => {
  return HTTP_WITHOUT_HEADER().post('user/verifySelfRegistration', data)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}



// WEBPACK FOOTER //
// ./src/app/login/api.js